const PREFIX = 'booking-site';

export const BOOKING_SITE_TRACKING_IDS = {
  locationStep: {
    itemSelect: `${PREFIX}:location-step:item-select`,
    clearButton: `${PREFIX}:location-step:clear-button`,
    nextButton: `${PREFIX}:location-step:next-button`,
  },
  appointmentTypeStep: {
    itemSelect: `${PREFIX}:appointment-type-step:item-select`,
    clearButton: `${PREFIX}:appointment-type-step:clear-button`,
    nextButton: `${PREFIX}:appointment-type-step:next-button`,
    previousButton: `${PREFIX}:appointment-type-step:previous-button`,
  },
  providerStep: {
    selectProviderNextButton: `${PREFIX}:provider-step:select-provider-next-button`,
    nextWeekButton: `${PREFIX}:provider-step:next-week-button`,
    previousWeekButton: `${PREFIX}:provider-step:previous-week-button`,
    nextAvailableSlotsButton: `${PREFIX}:provider-step:next-available-slots-button`,
    backToProviderListButton: `${PREFIX}:provider-step:back-to-provider-list-button`,
    noPreferenceButton: `${PREFIX}:provider-step:no-preference-button`,
    providerSelect: `${PREFIX}:provider-step:provider-select`,
    weekDaySelect: `${PREFIX}:provider-step:week-day-select`,
    slotSelect: `${PREFIX}:provider-step:slot-select`,
    clearButton: `${PREFIX}:provider-step:clear-button`,
    nextButton: `${PREFIX}:provider-step:next-button`,
    previousButton: `${PREFIX}:provider-step:previous-button`,
    weekAnchorDateInput: `${PREFIX}:provider-step:week-anchor-date-input`,
    weekAnchorDatePicker: `${PREFIX}:provider-step:week-anchor-date-picker`,
  },
  dateTimeStep: {
    previousButton: `${PREFIX}:date-time-step:previous-button`,
    nextButton: `${PREFIX}:date-time-step:next-button`,
    removeRequestedTimeButton: `${PREFIX}:date-time-step:remove-requested-time-button`,
  },
  patientInfoStep: {
    nextButton: `${PREFIX}:patient-info-step:next-button`,
    previousButton: `${PREFIX}:patient-info-step:previous-button`,
    concentCheckbox: `${PREFIX}:patient-info-step:consent-checkbox`,
  },
  paymentStep: {
    retryPaymentButton: `${PREFIX}:payment-step:retry-payment-button`,
    previousButton: `${PREFIX}:payment-step:previous-button`,
  },
  submitRequestButton: `${PREFIX}:submit-request-button`,
  privacyPolicyLink: `${PREFIX}:privacy-policy-link`,
};
